import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const branchOptions = [
  { id: 'commonOriginal', label: 'الجذع المشترك الأصيل' },

  { id: 'commonHumanities', label: 'جذع مشترك الآداب والعلوم الإنسانية' },
  { id: 'commonHumanitiesFrench', label: 'الجذع المشترك للآداب والعلوم الإنسانية – خيار فرنسية' },
  { id: 'commonHumanitiesEnglish', label: 'جذع المشترك للآداب والعلوم الإنسانية – خيار إنجليزية' },
  { id: 'commonHumanitiesSpanish', label: 'جذع المشترك للآداب والعلوم الإنسانية – خيار إسبانية' },

  { id: 'commonScience', label: 'الجذع المشترك العلمي' },
  { id: 'commonScienceFrench', label: 'الجذع المشترك العلمي – خيار فرنسية' },
  { id: 'commonScienceEnglish', label: 'الجذع المشترك العلمي – خيار إنجليزية' },
  { id: 'commonScienceSpanish', label: 'الجذع المشترك العلمي – خيار إسبانية' },

  { id: 'commonTechnology', label: 'الجذع المشترك التكنولوجي' },

  { id: 'commonProfessionalServices', label: 'جدع مشترك مهني خدماتي' },
  { id: 'commonProfessionalIndustry', label: 'جدع مشترك مهني صناعي' },
];

const PageLayout = () => {
    const navigate = useNavigate();
    const firstBranch = branchOptions[0]?.id || 'commonOriginal';
    const [selectedBranch, setSelectedBranch] = useState(firstBranch);
        const selectedBranchLabel = branchOptions.find((item) => item.id === selectedBranch)?.label || '';

        const handleConfirm = () => {
                navigate('/PageLayoutActionsV2', {
                        state: {
                                branch: selectedBranch,
                                branchLabel: selectedBranchLabel,
                        },
                });
        };

    return (
        <div>
            <div style={{ marginTop: '60px', marginBottom: '20px' }}></div>
            <div style={{ maxWidth: '700px', margin: 'auto', textAlign: 'right' }}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#00B9B9',
                        padding: '16px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                        direction: 'rtl',
                        fontFamily: 'Arial, sans-serif',
                        fontSize: '22px',
                        fontWeight: 'bold',
                        height: '80px',
                        gap: '20px',
                    }}
                >
                    <div style={{ width: '16px', height: '16px', backgroundColor: '#FF9900', borderRadius: '2px' }} />
                    <span>تدبير مجالس الأقســــام للجدع المشترك</span>
                    <div style={{ width: '16px', height: '16px', backgroundColor: '#FF9900', borderRadius: '2px' }} />
                </div>

                <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                    <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '8px', fontSize: '18px' }}>
                        : اختر نوع الجذع
                    </label>
                    <select
                        value={selectedBranch}
                        onChange={(e) => setSelectedBranch(e.target.value)}
                        style={{
                            width: '100%',
                            padding: '10px 12px',
                            borderRadius: '8px',
                            border: '1px solid #d0d7de',
                            fontSize: '18px',
                            textAlign: 'right',
                            backgroundColor: '#fff',
                        }}
                    >
                        {branchOptions.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.label}
                            </option>
                        ))}
                    </select>

                    <div style={{ marginTop: '12px', textAlign: 'center' }}>
                        <button
                            onClick={handleConfirm}
                            style={{
                                backgroundColor: '#1AA7A8',
                                color: 'white',
                                border: 'none',
                                borderRadius: '10px',
                                padding: '10px 24px',
                                fontWeight: 'bold',
                                fontSize: '18px',
                                cursor: 'pointer',
                            }}
                        >
                            تأكيد
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default PageLayout;
